import React, { useState } from "react";
import PropTypes from "prop-types";
import TextareaAutosize from "react-textarea-autosize";
import Label from "../Label/Label";
import styles from "./TextArea.module.scss";
import ErrorMessage from "../Form/ErrorMessage";
import clsx from "clsx";
import _ from "lodash";

const TextArea = React.forwardRef(
  (
    {
      defaultValue = "",
      errors = {},
      hideLabel = false,
      label,
      labelType,
      colorLabel,
      minRows = 5,
      name = "",
      placeholder,
      maxLength,
      disabled,
      className,
      required,
      errorMessages,
      onChange,
      dataTestId,
    },
    ref
  ) => {
    const [charLength, setCharLength] = useState(_.get(defaultValue, "length", 0));

    const textAreaContainerClasses = clsx(styles.textArea, className);

    const IS_ERROR = !!errors[name];

    const textAreaClasses = clsx("form-control", styles.textArea__input, {
      [styles.invalid]: IS_ERROR,
      [styles.primary]: !IS_ERROR,
    });

    return (
      <div className={textAreaContainerClasses} data-testid="TextArea">
        {!hideLabel ? (
          <Label
            color={colorLabel}
            disabled={disabled}
            required={required}
            htmlFor={name}
            type={labelType}
          >
            {label}
          </Label>
        ) : null}
        <TextareaAutosize
          id={name}
          name={name}
          className={textAreaClasses}
          data-testid={dataTestId}
          defaultValue={defaultValue}
          minRows={minRows}
          onChange={(e) => {
            onChange && onChange(e.target.value);
            setCharLength(e.target.value.length);
          }}
          placeholder={placeholder}
          ref={ref}
          maxLength={maxLength}
          disabled={disabled}
          required={required}
        />
        <div className="d-flex justify-content-between flex-row-reverse">
          {maxLength ? (
            <span className="text-footer" data-testid="MaxLength">
              ({charLength} / {maxLength})
            </span>
          ) : null}
        </div>
        <ErrorMessage errorMessages={errorMessages} errors={errors} label={label} name={name} />
      </div>
    );
  }
);

TextArea.propTypes = {
  defaultValue: PropTypes.string,
  errors: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
  errorMessages: PropTypes.object,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  colorLabel: PropTypes.string,
  minRows: PropTypes.number,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  dataTestId: PropTypes.string,
};

TextArea.defaultProps = {
  className: "",
  defaultValue: "",
  disabled: false,
  required: false,
  errors: {},
  errorMessages: {},
  hideLabel: false,
  labelColor: "default",
  label: "",
  minRows: 5,
  name: "",
  placeholder: "",
  dataTestId: "TextAreaAutosize",
};

export default TextArea;
